import PatientList from '@/views/Patient/PatientList';
import PatientAdd from '@/views/Patient/PatientAdd';
import PatientEdit from '@/views/Patient/PatientEdit';
import PatientDetail from '@/views/Patient/Detail/Detail';
import PatientPrintPreview from '@/views/Patient/PrintPreview';

import GenerateRxCertificate from '@/views/Prescription/RxCertificate';

const patient = [
  {
    path: 'patients/:id?/prescription/:prescription_id?/generate-rx',
    name: 'GenerateRxCertificate',
    component: GenerateRxCertificate
  },
  {
    path: 'patients',
    name: 'PatientList',
    component: PatientList
  },
  {
    path: 'patients/add',
    name: 'PatientAdd',
    component: PatientAdd
  },
  {
    path: 'patients/:id/detail',
    name: 'PatientDetail',
    component: PatientDetail
  },
  {
    path: 'patients/:id/edit',
    name: 'PatientEdit',
    component: PatientEdit
  },
  {
    path: 'patients/:id?/preview',
    name: 'PatientPrintPreview',
    component: PatientPrintPreview
  }
];

export default patient;



// WEBPACK FOOTER //
// ./src/router/modules/patient.js